/**
 * Allowed `bucketMetadata.dataType` values for snapshot payloads (PHIM dehydration, legacy snapshots).
 * Canonical home: encounter-events flow — not deprecated DB_EncounterSnapshot.
 */
export const EndEncounterDump = 'end-encounter-dump';
export const BugReportDump = 'bug-report-dump';
export const RetrospectiveDump = 'retrospective-dump';
export const InitEncounterDump = 'init-encounter-dump';
export const UpdateEncounterDump = 'update-encounter-dump';
export const DataTypes = [
    EndEncounterDump,
    BugReportDump,
    RetrospectiveDump,
    InitEncounterDump,
    UpdateEncounterDump,
];
//# sourceMappingURL=bucket-dump-types.js.map